import commonService from "./common.service";

const BASE = "/notifications";

const platformNotificationService = {
  list: (params = {}) => commonService.get(BASE, params, { silent: true }),
  listRecent: (limit = 10) =>
    commonService.get(`${BASE}/recent`, { limit }, { silent: true }),
  unreadCount: () => commonService.get(`${BASE}/unread-count`, {}, { silent: true }),
  statusCounts: () => commonService.get(`${BASE}/status-counts`, {}, { silent: true }),
  filterOptions: () => commonService.get(`${BASE}/filter-options`, {}, { silent: true }),
  getDetail: (notificationId) =>
    commonService.get(`${BASE}/${notificationId}`, {}, { silent: true }),
  markRead: (notificationId) =>
    commonService.post(`${BASE}/${notificationId}/read`, {}, { silent: true }),
  open: (notificationId) =>
    commonService.post(`${BASE}/${notificationId}/open`, {}, { silent: true }),
  markMultipleRead: (notificationIds) =>
    commonService.post(`${BASE}/mark-read`, { notificationIds }, { silent: true }),
  markAllRead: () => commonService.post(`${BASE}/mark-all-read`, {}, { silent: true }),
  archive: (notificationId) =>
    commonService.post(`${BASE}/${notificationId}/archive`, {}, { silent: true }),
  archiveMultiple: (notificationIds) =>
    commonService.post(`${BASE}/archive`, { notificationIds }, { silent: true }),
  archiveAllRead: () => commonService.post(`${BASE}/archive-all-read`, {}, { silent: true }),
  restore: (notificationId) =>
    commonService.post(`${BASE}/${notificationId}/restore`, {}, { silent: true }),
  restoreMultiple: (notificationIds) =>
    commonService.post(`${BASE}/restore`, { notificationIds }, { silent: true }),
  restoreAll: () => commonService.post(`${BASE}/restore-all`, {}, { silent: true }),
  markUnread: (notificationId) =>
    commonService.post(`${BASE}/${notificationId}/unread`, {}, { silent: true }),
  markMultipleUnread: (notificationIds) =>
    commonService.post(`${BASE}/mark-unread`, { notificationIds }, { silent: true }),
  deleteNotification: (notificationId) =>
    commonService.post(`${BASE}/${notificationId}/delete`, {}, { silent: true }),
  deleteMultiple: (notificationIds) =>
    commonService.post(`${BASE}/delete`, { notificationIds }, { silent: true }),
};

export default platformNotificationService;
